/**
 * FILTER UX V2 — native pill rail behavior for Blink/SEO collections (2026-07-16).
 * Loaded only by snippets/mt-blink-pillrail.liquid (variant templates, mobile UX).
 * Native filtering is GET-based: applying a filter reloads the page. A sessionStorage
 * flag makes the sheet reopen after the reload so filtering feels continuous (a URL
 * param won't survive — theme/Elevate scripts scrub the query string after load).
 */
(function () {
  'use strict';

  var rail = document.getElementById('mt-bfr');
  var drawer = document.getElementById('CollectionDrawer');
  var backdrop = document.querySelector('.mt-bfr-backdrop');
  var sortSheet = document.querySelector('.mt-bfr-sortsheet');
  if (!rail || !drawer) return;

  /* the template suffix that keeps the shopper in the variant — native GET
     navigations drop the view= param, so every link/form we own re-adds it */
  var suffix = rail.getAttribute('data-suffix');
  function withView(href) {
    var u = new URL(href, window.location.origin);
    if (suffix) u.searchParams.set('view', suffix);
    return u.toString();
  }

  function track(name, params) {
    try {
      params = params || {};
      params.mt_variant = 'b';
      params.engine = 'native';
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
    } catch (e) { /* never break the UI */ }
  }

  /* sticky offset below the theme header (same approach as mt-filter-v2.js) */
  function setHeaderOffset() {
    var header = document.querySelector('#shopify-section-header-top');
    var h = header ? Math.round(header.getBoundingClientRect().height) : 49;
    document.documentElement.style.setProperty('--mt-bfr-top', h + 'px');
  }
  setHeaderOffset();
  window.addEventListener('resize', setHeaderOffset);

  /* pinned chrome inside the drawer: header title on top (the theme's in-content
     REFINE BY heading is hidden while the sheet is open — it would scroll away),
     footer [Clear all] [Show results (N)] on the bottom */
  function ensureChrome() {
    if (!drawer.querySelector('.mt-bfr-sheet-header')) {
      var header = document.createElement('div');
      header.className = 'mt-bfr-sheet-header';
      header.textContent = 'Refine By';
      drawer.insertBefore(header, drawer.firstChild);
    }
    if (drawer.querySelector('.mt-bfr-footer')) return;
    var count = (document.getElementById('ProductCount') || {}).textContent || '';
    var n = (count.match(/\d+/) || [''])[0];
    var footer = document.createElement('div');
    footer.className = 'mt-bfr-footer';
    footer.innerHTML =
      '<a class="mt-bfr-footer-clear" href="' + withView(window.location.pathname.split('?')[0]) + '">Clear all</a>' +
      '<button type="button" class="mt-bfr-footer-show">Show results' + (n ? ' (' + n + ')' : '') + '</button>';
    drawer.appendChild(footer);
    /* Show results is the ONE apply action: if the price inputs were edited, submit
       the form (GET reload, landing on results); otherwise just close. The in-group
       Apply/Reset pair is hidden in the sheet (CSS) — four stacked buttons confused
       shoppers (Amy). Control keeps Apply/Reset. */
    footer.querySelector('.mt-bfr-footer-show').addEventListener('click', function () {
      var gte = drawer.querySelector('input[name="filter.v.price.gte"]');
      var lte = drawer.querySelector('input[name="filter.v.price.lte"]');
      var pending = [gte, lte].some(function (el) {
        return el && (el.value || '') !== (el.getAttribute('value') || '');
      });
      if (pending && gte) {
        track('mt_fv2_filter_apply', {});
        gte.form.submit();
        return;
      }
      closeSheet();
    });
  }

  var sheetOpen = false;
  function openSheet(facetLabel) {
    ensureChrome();
    drawer.classList.add('mt-bfr-open');
    if (backdrop) backdrop.hidden = false;
    document.body.classList.add('mt-bfr-lock');
    sheetOpen = true;
    track('mt_fv2_sheet_open', {});
    /* accordion, matching the Boost sheet: collapse every group; a tapped facet pill
       (or the facet just applied, on reopen) is the only one expanded. Without this
       the sheet is one giant scroll of every open facet. */
    setTimeout(function () {
      var groups = drawer.querySelectorAll('details');
      var target = null;
      for (var i = 0; i < groups.length; i++) {
        /* skip hidden groups (the deduped legacy Material/Color/Artist facets) —
           matching one of those scrolls nowhere */
        if (groups[i].offsetParent === null) continue;
        groups[i].open = false;
        var heading = groups[i].querySelector('.blink-facet-heading');
        if (!target && facetLabel && heading && heading.textContent.trim() === facetLabel) {
          target = groups[i];
        }
      }
      if (target) {
        target.open = true;
        target.scrollIntoView({ block: 'start' });
      } else {
        var wrapper = drawer.querySelector('.collection-sidebar-wrapper');
        if (wrapper) wrapper.scrollTop = 0;
      }
    }, 120);
  }

  function closeSheet() {
    drawer.classList.remove('mt-bfr-open');
    if (backdrop) backdrop.hidden = true;
    document.body.classList.remove('mt-bfr-lock');
    sheetOpen = false;
  }

  function openSort() {
    if (!sortSheet) return;
    sortSheet.hidden = false;
    if (backdrop) backdrop.hidden = false;
    document.body.classList.add('mt-bfr-lock');
  }

  function closeSort() {
    if (sortSheet) sortSheet.hidden = true;
    if (!sheetOpen && backdrop) backdrop.hidden = true;
    if (!sheetOpen) document.body.classList.remove('mt-bfr-lock');
  }

  rail.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    /* applied chips are server-rendered links whose hrefs (url_to_remove /
       collection.url) don't carry view= — re-add it before navigating */
    var chip = e.target.closest('a.mt-bfr-chip');
    if (chip) {
      e.preventDefault();
      track('mt_fv2_chip_remove', {});
      window.location.assign(withView(chip.getAttribute('href')));
      return;
    }
    var all = e.target.closest('[data-bfr-open]');
    if (all) { openSheet(null); return; }
    var sort = e.target.closest('[data-bfr-sort]');
    if (sort) { openSort(); track('mt_fv2_sort', {}); return; }
    var pill = e.target.closest('[data-bfr-facet]');
    if (pill) {
      track('mt_fv2_pill_tap', { facet: pill.getAttribute('data-bfr-facet') });
      openSheet(pill.getAttribute('data-bfr-facet'));
    }
  });

  if (sortSheet) sortSheet.addEventListener('click', function (e) {
    if (e.target.closest('[data-bfr-sort-close]')) { closeSort(); return; }
    var opt = e.target.closest('.mt-bfr-sort-option');
    if (!opt) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', opt.getAttribute('data-sort'));
    if (suffix) url.searchParams.set('view', suffix);
    window.location.assign(url.toString());
  });

  if (backdrop) backdrop.addEventListener('click', function () {
    if (sortSheet && !sortSheet.hidden) { closeSort(); return; }
    closeSheet();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (sortSheet && !sortSheet.hidden) { closeSort(); return; }
    if (sheetOpen) closeSheet();
  });
  var nativeClose = document.getElementById('closeDrawerBtn');
  if (nativeClose) nativeClose.addEventListener('click', closeSheet);

  /* The native filter form's GET drops every non-filter query param — including the
     view=<suffix> that selects the variant template. Re-inject it from server truth
     (data-suffix) so applying a filter keeps the shopper in the variant. */
  document.querySelectorAll('form.filter__form').forEach(function (form) {
    if (suffix && !form.querySelector('input[name="view"]')) {
      var v = document.createElement('input');
      v.type = 'hidden';
      v.name = 'view';
      v.value = suffix;
      form.appendChild(v);
    }
  });

  /* Reopen the sheet after the filter reload so filtering feels continuous.
     The checkboxes submit via inline this.form.submit(), which per spec does NOT
     fire a submit event — so hook `change` in the CAPTURE phase (runs before the
     inline handler navigates) and stash a sessionStorage flag, plus the facet the
     shopper was in so the accordion reopens to that group. */
  function markReopen(facetLabel) {
    try {
      sessionStorage.setItem('mtBfrReopen', '1');
      sessionStorage.setItem('mtBfrReopenFacet', facetLabel || '');
    } catch (e) { }
  }
  drawer.addEventListener('change', function (e) {
    if (!sheetOpen) return;
    if (!e.target.closest('form.filter__form')) return;
    /* price edits fire change on blur but apply via Show results — no reopen */
    if ((e.target.name || '').indexOf('filter.v.price') === 0) return;
    var det = e.target.closest('details');
    var heading = det ? det.querySelector('.blink-facet-heading') : null;
    markReopen(heading ? heading.textContent.trim() : '');
    track('mt_fv2_filter_apply', {});
  }, true);

  /* The theme's Active Filters block renders each native selection twice: a native
     remove chip (a.active-facets__button "Material: Wood ✕") plus a standalone legacy
     blink chip ("Wood X"). Tag the legacy copy when a native chip already shows the
     same value — CSS hides it in the mobile sheet only. */
  var nativeChips = Array.from(drawer.querySelectorAll('.active-filters a.active-facets__button'));
  drawer.querySelectorAll('.active-filters > div.blink-active-facets__button-inner').forEach(function (legacy) {
    var val = legacy.textContent.replace(/\s*X\s*$/, '').trim().toLowerCase();
    if (!val) return;
    var dup = nativeChips.some(function (n) { return n.textContent.toLowerCase().indexOf(val) !== -1; });
    if (dup) legacy.classList.add('mt-bfr-dup');
  });

  /* native remove chips inside the drawer are plain url_to_remove links — keep the
     shopper in the variant when they tap one */
  drawer.addEventListener('click', function (e) {
    var link = e.target.closest('a.active-facets__button');
    if (!link || !suffix) return;
    e.preventDefault();
    track('mt_fv2_chip_remove', {});
    window.location.assign(withView(link.getAttribute('href')));
  });
  try {
    if (sessionStorage.getItem('mtBfrReopen') === '1') {
      sessionStorage.removeItem('mtBfrReopen');
      var reopenFacet = sessionStorage.getItem('mtBfrReopenFacet') || '';
      sessionStorage.removeItem('mtBfrReopenFacet');
      openSheet(reopenFacet || null);
    }
  } catch (e) { }

  /* DESKTOP GRID 2026 topbar (2026-08-04): variant-only desktop behaviors — this file
     also loads on the default template, so everything below is guarded on the topbar
     scope class. The bar is a second render of the same native filter form (id-prefixed);
     the All Filters button opens the existing drawer as a desktop slide-over (the theme's
     close/backdrop/ESC bindings already handle closing). */
  var dgRoot = document.querySelector('.mt-dgrid-blink-topbar');
  if (dgRoot) {
    var dgBar = dgRoot.querySelector('.mt-dgrid-blink-bar');
    if (dgBar) {
      /* one dropdown open at a time ('toggle' doesn't bubble — capture phase) */
      dgBar.addEventListener('toggle', function (e) {
        var d = e.target;
        if (!d.matches || !d.matches('details.filter-group') || !d.open) return;
        dgBar.querySelectorAll('details.filter-group[open]').forEach(function (o) {
          if (o !== d) o.open = false;
        });
      }, true);
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.mt-dgrid-blink-bar')) return;
        dgBar.querySelectorAll('details.filter-group[open]').forEach(function (o) { o.open = false; });
      });
    }
    var dgAllBtn = document.getElementById('mtDgOpenDrawerBtn');
    if (dgAllBtn) dgAllBtn.addEventListener('click', function () {
      drawer.classList.add('drawer-open');
      track('mt_fv2_sheet_open', {});
    });
    /* page backdrop for the desktop slide-over: the theme's own modal-background is a
       CHILD of the drawer (showing it veils the panel — the "black panel" bug), so we
       manage a sibling backdrop and sync it to the drawer's class for every close path */
    var dgBackdrop = document.createElement('div');
    dgBackdrop.className = 'mt-dgrid-allfilters-backdrop';
    dgBackdrop.hidden = true;
    document.body.appendChild(dgBackdrop);
    dgBackdrop.addEventListener('click', function () { drawer.classList.remove('drawer-open'); });
    new MutationObserver(function () {
      dgBackdrop.hidden = !drawer.classList.contains('drawer-open');
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    /* desktop applied chips + per-facet Clear links: url_to_remove drops view= —
       re-add it (the rail's chip handler is #mt-bfr-scoped and doesn't cover these) */
    dgRoot.addEventListener('click', function (e) {
      var chip = e.target.closest && e.target.closest('a.mt-dgrid-chip, a.mt-dgrid-facet-clear, a.mt-dgrid-clearall-pill');
      if (!chip) return;
      e.preventDefault();
      track('mt_fv2_chip_remove', {});
      window.location.assign(withView(chip.getAttribute('href')));
    });
  }

  track('mt_fv2_pageview', { page_type: 'collection_native' });
})();
/* Pinned filter bar on scroll (Quince): sticky is dead under the theme's
   overflow:hidden main wrapper — toggle fixed positioning + a spacer instead. */
(function () {
  'use strict';
  var bar = document.querySelector('.mt-dgrid-blink-topbar .collection__filter-container');
  if (!bar || !window.matchMedia('(min-width: 768px)').matches) return;
  var spacer = document.createElement('div');
  spacer.style.display = 'none';
  bar.parentNode.insertBefore(spacer, bar.nextSibling);
  /* pin offset = live bottom of the theme's stacked sticky header sections
     (top strip + nav; ~123px on desktop, taller than the mobile-oriented CSS var) */
  function headerH() {
    var t = 0;
    ['#shopify-section-header-top', '#shopify-section-header'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      var cs = getComputedStyle(el);
      if (cs.position === 'sticky' || cs.position === 'fixed') {
        var bRect = el.getBoundingClientRect().bottom;
        if (bRect > t) t = bRect;
      }
    });
    return t;
  }
  /* Fully LIVE pinning — no cached threshold, no frozen top offset. A fast scroll
     during page load used to capture the header's bottom mid-flight (announcement
     bars still in view, images still shifting layout) and freeze the bar with a gap
     below the header. Now every scroll frame re-reads the real geometry: the bar
     sticks when its natural position reaches the header, the pinned top self-corrects
     each frame, and the spacer (which holds the bar's natural slot) drives unsticking. */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var h = headerH();
      if (!bar.classList.contains('mt-stuck')) {
        if (bar.getBoundingClientRect().top <= h - 2) {
          spacer.style.height = bar.offsetHeight + 'px';
          spacer.style.display = 'block';
          /* tuck 4px up under the header's bottom padding — tighter join, no pill
             clipping (the bar's own top padding absorbs the overlap) */
          bar.style.top = (h - 4) + 'px';
          bar.classList.add('mt-stuck');
        }
      } else {
        bar.style.top = (h - 4) + 'px';
        if (spacer.getBoundingClientRect().top > h - 2) {
          bar.classList.remove('mt-stuck');
          bar.style.top = '';
          spacer.style.display = 'none';
        }
      }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', onScroll);
  setTimeout(onScroll, 400); /* browser-restored scroll positions pin immediately */
})();
